import React from 'react';
import { Link } from 'react-router-dom';
import useSEO from '../hooks/useSEO';

const NotFound = () => {
  useSEO({
    title: "404 – Page non trouvée – Expomis",
    description: "La page que vous recherchez n'existe pas ou plus.",
    path: '/404',
    noindex: true
  });

  return (
    <div className="pt-40 pb-24 min-h-screen flex items-center justify-center">
      <div className="text-center container mx-auto px-6">
        <div className="text-xs font-semibold tracking-widest uppercase text-brand mb-4">Erreur 404</div>
        <h1 className="font-serif text-5xl font-semibold text-ink mb-6">Page non trouvée</h1>
        <p className="text-lg text-ink-soft mb-8">
          Désolé, la page que vous recherchez n'existe pas.
        </p>
        <Link
          to="/"
          className="inline-block bg-ink text-white px-8 py-4 font-medium hover:bg-brand-deep transition-colors"
        >
          Retour à l'accueil
        </Link>
      </div>
    </div>
  );
};

export default NotFound;
